/**
 * @generated SignedSource<<ba44d6eb5d10e9a03ba8c92a519a8b09>>
 * @relayHash 39d9663ba0233a929ed631420222f710
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 39d9663ba0233a929ed631420222f710

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type UserNameDisplayConfiguration = "HANDLE" | "NAME_AND_HANDLE" | "%future added value";
export type IssueViewerViewQuery$variables = {
  allowedOwner?: string | null | undefined;
  count?: number | null | undefined;
  hideTimeline?: boolean | null | undefined;
  number: number;
  owner: string;
  repo: string;
  skip?: number | null | undefined;
};
export type IssueViewerViewQuery$data = {
  readonly repository: Result<{
    readonly id: string;
    readonly isOwnerEnterpriseManaged: boolean | null | undefined;
    readonly issue: Result<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"IssueViewerIssue">;
    } | null | undefined, unknown>;
    readonly owner: {
      readonly userNameDisplayConfiguration: UserNameDisplayConfiguration;
    };
  } | null | undefined, unknown>;
  readonly safeViewer: {
    readonly __typename: "User";
    readonly avatarUrl: string;
    readonly enterpriseManagedEnterpriseId: string | null | undefined;
    readonly id: string;
    readonly isEnterpriseManagedUser: boolean | null | undefined;
    readonly login: string;
    readonly name: string | null | undefined;
    readonly profileResourcePath: string | null | undefined;
  } | null | undefined;
};
export type IssueViewerViewQuery = {
  response: IssueViewerViewQuery$data;
  variables: IssueViewerViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "allowedOwner"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "hideTimeline"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "number"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "repo"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v7 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "repo"
  },
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "kind": "RequiredField",
  "field": (v8/*:: as any*/),
  "action": "THROW"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOwnerEnterpriseManaged",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userNameDisplayConfiguration",
  "storageKey": null
},
v12 = [
  {
    "kind": "Variable",
    "name": "number",
    "variableName": "number"
  }
],
v13 = {
  "kind": "Variable",
  "name": "allowedOwner",
  "variableName": "allowedOwner"
},
v14 = {
  "kind": "Variable",
  "name": "skip",
  "variableName": "skip"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileResourcePath",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "safeViewer",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEnterpriseManagedUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enterpriseManagedEnterpriseId",
      "storageKey": null
    },
    (v15/*:: as any*/),
    (v16/*:: as any*/),
    (v8/*:: as any*/),
    (v17/*:: as any*/),
    (v18/*:: as any*/),
    (v19/*:: as any*/)
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slashCommandsEnabled",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v29 = [
  (v28/*:: as any*/)
],
v30 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v31 = [
  (v30/*:: as any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataType",
  "storageKey": null
},
v33 = [
  (v8/*:: as any*/),
  (v17/*:: as any*/),
  (v32/*:: as any*/),
  (v26/*:: as any*/)
],
v34 = {
  "kind": "InlineFragment",
  "selections": (v33/*:: as any*/),
  "type": "IssueFieldText",
  "abstractKey": null
},
v35 = {
  "kind": "InlineFragment",
  "selections": (v33/*:: as any*/),
  "type": "IssueFieldSingleSelect",
  "abstractKey": null
},
v36 = {
  "kind": "InlineFragment",
  "selections": (v33/*:: as any*/),
  "type": "IssueFieldMultiSelect",
  "abstractKey": null
},
v37 = {
  "kind": "InlineFragment",
  "selections": (v33/*:: as any*/),
  "type": "IssueFieldDate",
  "abstractKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": (v33/*:: as any*/),
  "type": "IssueFieldNumber",
  "abstractKey": null
},
v39 = [
  (v8/*:: as any*/)
],
v40 = {
  "kind": "InlineFragment",
  "selections": (v39/*:: as any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v41 = [
  (v16/*:: as any*/),
  (v34/*:: as any*/),
  (v35/*:: as any*/),
  (v36/*:: as any*/),
  (v37/*:: as any*/),
  (v38/*:: as any*/),
  (v40/*:: as any*/)
],
v42 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      }
    ],
    "concreteType": "IssueFieldsConnection",
    "kind": "LinkedField",
    "name": "issueFields",
    "plural": false,
    "selections": (v29/*:: as any*/),
    "storageKey": "issueFields(first:1)"
  },
  {
    "alias": null,
    "args": (v31/*:: as any*/),
    "concreteType": "IssueFieldsConnection",
    "kind": "LinkedField",
    "name": "pinnedIssueFields",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": (v41/*:: as any*/),
        "storageKey": null
      }
    ],
    "storageKey": "pinnedIssueFields(first:100)"
  }
],
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v47 = [
  (v16/*:: as any*/),
  (v15/*:: as any*/),
  (v8/*:: as any*/)
],
v48 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v47/*:: as any*/),
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v17/*:: as any*/),
    (v48/*:: as any*/),
    (v8/*:: as any*/)
  ],
  "storageKey": null
},
v50 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCopilot",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAgent",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v56/*:: as any*/),
    (v57/*:: as any*/)
  ],
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameHTML",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archivedAt",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closed",
  "storageKey": null
},
v63 = {
  "kind": "InlineFragment",
  "selections": [
    (v53/*:: as any*/),
    (v54/*:: as any*/),
    (v55/*:: as any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locked",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerDidAuthor",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileUrl",
  "storageKey": null
},
v70 = [
  (v17/*:: as any*/)
],
v71 = {
  "kind": "InlineFragment",
  "selections": (v70/*:: as any*/),
  "type": "User",
  "abstractKey": null
},
v72 = {
  "kind": "InlineFragment",
  "selections": (v70/*:: as any*/),
  "type": "EnterpriseUserAccount",
  "abstractKey": null
},
v73 = {
  "kind": "InlineFragment",
  "selections": (v70/*:: as any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "unfurlReferences",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": "bodyHTML(unfurlReferences:true)"
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyVersion",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "ReactionGroup",
  "kind": "LinkedField",
  "name": "reactionGroups",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerHasReacted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v50/*:: as any*/)
      ],
      "concreteType": "ReactorConnection",
      "kind": "LinkedField",
      "name": "reactors",
      "plural": false,
      "selections": [
        (v28/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v16/*:: as any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v15/*:: as any*/),
                (v17/*:: as any*/),
                (v19/*:: as any*/),
                (v63/*:: as any*/)
              ],
              "type": "Actor",
              "abstractKey": "__isActor"
            },
            (v40/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "reactors(first:10)"
    }
  ],
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnpin",
  "storageKey": null
},
v79 = {
  "kind": "Literal",
  "name": "first",
  "value": 25
},
v80 = [
  {
    "kind": "Literal",
    "name": "allowSameEnterprise",
    "value": true
  },
  (v13/*:: as any*/),
  (v79/*:: as any*/)
],
v81 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "Status"
  }
],
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optionId",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdate",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanDelete",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "intentId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v16/*:: as any*/),
    (v15/*:: as any*/),
    (v17/*:: as any*/),
    (v68/*:: as any*/),
    (v88/*:: as any*/),
    (v8/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v55/*:: as any*/)
      ],
      "type": "Bot",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confidence",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rationale",
  "storageKey": null
},
v92 = [
  (v8/*:: as any*/),
  (v17/*:: as any*/),
  (v45/*:: as any*/)
],
v93 = [
  (v17/*:: as any*/),
  (v45/*:: as any*/),
  (v8/*:: as any*/)
],
v94 = [
  (v21/*:: as any*/),
  (v61/*:: as any*/),
  (v27/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Repository",
    "kind": "LinkedField",
    "name": "repository",
    "plural": false,
    "selections": [
      (v24/*:: as any*/),
      (v8/*:: as any*/)
    ],
    "storageKey": null
  }
],
v95 = {
  "kind": "Literal",
  "name": "visibleEventsOnly",
  "value": true
},
v96 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v14/*:: as any*/),
  (v95/*:: as any*/)
],
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pendingBlock",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pendingUnblock",
  "storageKey": null
},
v99 = [
  (v16/*:: as any*/),
  (v40/*:: as any*/)
],
v100 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v8/*:: as any*/),
    (v17/*:: as any*/),
    (v43/*:: as any*/),
    (v48/*:: as any*/)
  ],
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInMergeQueue",
  "storageKey": null
},
v102 = [
  (v16/*:: as any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v8/*:: as any*/),
      (v44/*:: as any*/),
      (v27/*:: as any*/),
      (v21/*:: as any*/),
      (v65/*:: as any*/),
      (v100/*:: as any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v8/*:: as any*/),
      {
        "alias": "pullTitleHTML",
        "args": null,
        "kind": "ScalarField",
        "name": "titleHTML",
        "storageKey": null
      },
      (v27/*:: as any*/),
      (v21/*:: as any*/),
      (v51/*:: as any*/),
      (v52/*:: as any*/),
      (v101/*:: as any*/),
      (v100/*:: as any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  },
  (v40/*:: as any*/)
],
v103 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v8/*:: as any*/),
    (v60/*:: as any*/),
    (v59/*:: as any*/),
    (v17/*:: as any*/),
    (v45/*:: as any*/),
    (v46/*:: as any*/)
  ],
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    (v91/*:: as any*/)
  ],
  "storageKey": null
},
v105 = {
  "kind": "InlineFragment",
  "selections": [
    (v15/*:: as any*/)
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
},
v106 = [
  (v8/*:: as any*/),
  (v15/*:: as any*/),
  (v88/*:: as any*/),
  (v17/*:: as any*/)
],
v107 = {
  "kind": "InlineFragment",
  "selections": (v106/*:: as any*/),
  "type": "User",
  "abstractKey": null
},
v108 = {
  "kind": "InlineFragment",
  "selections": (v106/*:: as any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v109 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*:: as any*/),
    (v15/*:: as any*/),
    (v88/*:: as any*/)
  ],
  "type": "Organization",
  "abstractKey": null
},
v110 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*:: as any*/),
    (v15/*:: as any*/),
    (v88/*:: as any*/),
    (v53/*:: as any*/),
    (v55/*:: as any*/),
    (v54/*:: as any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v111 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "milestoneTitle",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Milestone",
    "kind": "LinkedField",
    "name": "milestone",
    "plural": false,
    "selections": [
      (v8/*:: as any*/),
      (v27/*:: as any*/)
    ],
    "storageKey": null
  }
],
v112 = [
  (v17/*:: as any*/),
  (v32/*:: as any*/)
],
v113 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    (v16/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": (v112/*:: as any*/),
      "type": "IssueFieldText",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v112/*:: as any*/),
      "type": "IssueFieldDate",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v112/*:: as any*/),
      "type": "IssueFieldNumber",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v112/*:: as any*/),
      "type": "IssueFieldSingleSelect",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v112/*:: as any*/),
      "type": "IssueFieldMultiSelect",
      "abstractKey": null
    },
    (v40/*:: as any*/)
  ],
  "storageKey": null
},
v114 = [
  (v17/*:: as any*/),
  (v45/*:: as any*/)
],
v115 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueComment",
    "kind": "LinkedField",
    "name": "issueComment",
    "plural": false,
    "selections": [
      (v8/*:: as any*/),
      (v27/*:: as any*/),
      (v22/*:: as any*/)
    ],
    "storageKey": null
  }
],
v116 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviatedOid",
  "storageKey": null
},
v117 = [
  (v16/*:: as any*/),
  (v8/*:: as any*/),
  (v44/*:: as any*/),
  (v27/*:: as any*/),
  (v21/*:: as any*/),
  (v65/*:: as any*/),
  (v100/*:: as any*/)
],
v118 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "blockingIssue",
  "plural": false,
  "selections": (v117/*:: as any*/),
  "storageKey": null
},
v119 = [
  (v8/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v117/*:: as any*/),
    "storageKey": null
  }
],
v120 = [
  (v8/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "relatedIssue",
    "plural": false,
    "selections": (v117/*:: as any*/),
    "storageKey": null
  }
],
v121 = [
  (v16/*:: as any*/),
  (v8/*:: as any*/),
  (v44/*:: as any*/),
  (v27/*:: as any*/),
  (v21/*:: as any*/),
  (v65/*:: as any*/),
  (v100/*:: as any*/),
  (v22/*:: as any*/)
],
v122 = [
  (v8/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v121/*:: as any*/),
    "storageKey": null
  }
],
v123 = [
  (v8/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v121/*:: as any*/),
    "storageKey": null
  }
],
v124 = [
  (v8/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v16/*:: as any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v61/*:: as any*/),
          (v27/*:: as any*/),
          (v21/*:: as any*/),
          (v51/*:: as any*/),
          (v52/*:: as any*/),
          (v101/*:: as any*/),
          (v49/*:: as any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      },
      (v40/*:: as any*/)
    ],
    "storageKey": null
  }
],
v125 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "canonical",
  "plural": false,
  "selections": (v102/*:: as any*/),
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanonicalOfClosedDuplicate",
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v61/*:: as any*/),
    (v27/*:: as any*/),
    (v8/*:: as any*/)
  ],
  "storageKey": null
},
v128 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v93/*:: as any*/),
  "storageKey": null
},
v129 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueTimelineItemsEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v16/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v22/*:: as any*/),
            (v66/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "actor",
              "plural": false,
              "selections": [
                (v8/*:: as any*/),
                (v19/*:: as any*/),
                (v15/*:: as any*/),
                (v18/*:: as any*/),
                (v16/*:: as any*/),
                (v63/*:: as any*/),
                (v71/*:: as any*/),
                (v72/*:: as any*/),
                (v73/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "TimelineEvent",
          "abstractKey": "__isTimelineEvent"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v22/*:: as any*/),
            (v67/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Issue",
              "kind": "LinkedField",
              "name": "issue",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": (v47/*:: as any*/),
                  "storageKey": null
                },
                (v8/*:: as any*/),
                (v21/*:: as any*/),
                (v64/*:: as any*/),
                (v22/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "author",
              "plural": false,
              "selections": [
                (v16/*:: as any*/),
                (v15/*:: as any*/),
                (v68/*:: as any*/),
                (v69/*:: as any*/),
                (v8/*:: as any*/),
                (v71/*:: as any*/),
                (v72/*:: as any*/),
                (v73/*:: as any*/)
              ],
              "storageKey": null
            },
            (v8/*:: as any*/),
            (v27/*:: as any*/),
            (v66/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "authorAssociation",
              "storageKey": null
            },
            (v85/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanMinimize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanUnminimize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanReport",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanReportToMaintainer",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanBlockFromOrg",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanUnblockFromOrg",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanBlockPersonally",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanUnblockPersonally",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanPin",
              "storageKey": null
            },
            (v78/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "App",
              "kind": "LinkedField",
              "name": "viaApp",
              "plural": false,
              "selections": [
                (v17/*:: as any*/),
                (v27/*:: as any*/),
                (v8/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minimizedReason",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showSpammyBadge",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdViaEmail",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Sponsorship",
              "kind": "LinkedField",
              "name": "authorToRepoOwnerSponsorship",
              "plural": false,
              "selections": [
                (v66/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isActive",
                  "storageKey": null
                },
                (v8/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanReadUserContentEdits",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastEditedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserContentEdit",
              "kind": "LinkedField",
              "name": "lastUserContentEdit",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "editor",
                  "plural": false,
                  "selections": [
                    (v16/*:: as any*/),
                    (v27/*:: as any*/),
                    (v15/*:: as any*/),
                    (v8/*:: as any*/)
                  ],
                  "storageKey": null
                },
                (v8/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "pinnedBy",
              "plural": false,
              "selections": [
                (v15/*:: as any*/),
                (v8/*:: as any*/)
              ],
              "storageKey": null
            },
            (v74/*:: as any*/),
            (v75/*:: as any*/),
            (v76/*:: as any*/),
            {
              "alias": "isHidden",
              "args": null,
              "kind": "ScalarField",
              "name": "isMinimized",
              "storageKey": null
            },
            (v83/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Repository",
              "kind": "LinkedField",
              "name": "repository",
              "plural": false,
              "selections": [
                (v8/*:: as any*/),
                (v17/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "owner",
                  "plural": false,
                  "selections": [
                    (v16/*:: as any*/),
                    (v8/*:: as any*/),
                    (v15/*:: as any*/),
                    (v27/*:: as any*/)
                  ],
                  "storageKey": null
                },
                (v43/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "viewerCanCreateIssues",
                  "storageKey": null
                },
                (v25/*:: as any*/),
                (v24/*:: as any*/),
                (v22/*:: as any*/)
              ],
              "storageKey": null
            },
            (v77/*:: as any*/),
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pendingMinimizeReason",
                  "storageKey": null
                },
                (v97/*:: as any*/),
                (v98/*:: as any*/)
              ]
            }
          ],
          "type": "IssueComment",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "source",
              "plural": false,
              "selections": (v99/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "willCloseTarget",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "referencedAt",
              "storageKey": null
            },
            (v22/*:: as any*/),
            {
              "alias": "innerSource",
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "source",
              "plural": false,
              "selections": (v102/*:: as any*/),
              "storageKey": null
            }
          ],
          "type": "CrossReferencedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v103/*:: as any*/),
            (v8/*:: as any*/),
            (v104/*:: as any*/)
          ],
          "type": "LabeledEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v103/*:: as any*/),
            (v8/*:: as any*/)
          ],
          "type": "UnlabeledEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "assignee",
              "plural": false,
              "selections": [
                (v16/*:: as any*/),
                (v105/*:: as any*/),
                (v107/*:: as any*/),
                (v108/*:: as any*/),
                (v109/*:: as any*/),
                (v110/*:: as any*/),
                (v40/*:: as any*/)
              ],
              "storageKey": null
            },
            (v104/*:: as any*/)
          ],
          "type": "AssignedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "assignee",
              "plural": false,
              "selections": [
                (v16/*:: as any*/),
                (v107/*:: as any*/),
                (v110/*:: as any*/),
                (v108/*:: as any*/),
                (v109/*:: as any*/),
                (v40/*:: as any*/),
                (v105/*:: as any*/)
              ],
              "storageKey": null
            },
            (v8/*:: as any*/)
          ],
          "type": "UnassignedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v111/*:: as any*/),
          "type": "MilestonedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v111/*:: as any*/),
          "type": "DemilestonedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v113/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "IssueFieldTimelineOption",
              "kind": "LinkedField",
              "name": "options",
              "plural": true,
              "selections": (v114/*:: as any*/),
              "storageKey": null
            },
            (v86/*:: as any*/),
            (v45/*:: as any*/),
            (v104/*:: as any*/)
          ],
          "type": "IssueFieldAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v113/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "newColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IssueFieldTimelineOption",
              "kind": "LinkedField",
              "name": "newOptions",
              "plural": true,
              "selections": (v114/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "newValue",
              "storageKey": null
            },
            (v104/*:: as any*/)
          ],
          "type": "IssueFieldChangedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v113/*:: as any*/),
            (v104/*:: as any*/)
          ],
          "type": "IssueFieldRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v115/*:: as any*/),
          "type": "IssueCommentPinnedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v115/*:: as any*/),
          "type": "IssueCommentUnpinnedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*:: as any*/),
          "type": "SubscribedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*:: as any*/),
          "type": "UnsubscribedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*:: as any*/),
          "type": "MentionedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v22/*:: as any*/),
            (v66/*:: as any*/),
            (v65/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "duplicateOf",
              "plural": false,
              "selections": (v102/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "closingProjectItemStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "closer",
              "plural": false,
              "selections": [
                (v16/*:: as any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v27/*:: as any*/),
                    (v61/*:: as any*/)
                  ],
                  "type": "ProjectV2",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v27/*:: as any*/),
                    (v21/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Repository",
                      "kind": "LinkedField",
                      "name": "repository",
                      "plural": false,
                      "selections": [
                        (v8/*:: as any*/),
                        (v17/*:: as any*/),
                        (v48/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "PullRequest",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v27/*:: as any*/),
                    (v116/*:: as any*/),
                    (v49/*:: as any*/)
                  ],
                  "type": "Commit",
                  "abstractKey": null
                },
                (v40/*:: as any*/)
              ],
              "storageKey": null
            },
            (v8/*:: as any*/),
            (v104/*:: as any*/)
          ],
          "type": "ClosedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*:: as any*/),
          "type": "ReopenedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lockReason",
              "storageKey": null
            },
            (v8/*:: as any*/)
          ],
          "type": "LockedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*:: as any*/),
          "type": "UnlockedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*:: as any*/),
          "type": "PinnedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*:: as any*/),
          "type": "UnpinnedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "previousTitle",
              "storageKey": null
            }
          ],
          "type": "RenamedTitleEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*:: as any*/),
            (v118/*:: as any*/)
          ],
          "type": "BlockedByAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v22/*:: as any*/),
            (v8/*:: as any*/),
            (v66/*:: as any*/),
            (v118/*:: as any*/)
          ],
          "type": "BlockedByRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v119/*:: as any*/),
          "type": "BlockingAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v119/*:: as any*/),
          "type": "BlockingRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v120/*:: as any*/),
          "type": "RelatesToAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v120/*:: as any*/),
          "type": "RelatesToRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "deletedCommentAuthor",
              "plural": false,
              "selections": [
                (v16/*:: as any*/),
                (v15/*:: as any*/),
                (v71/*:: as any*/),
                (v73/*:: as any*/),
                (v72/*:: as any*/),
                (v8/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "CommentDeletedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "blockDuration",
              "storageKey": null
            },
            (v8/*:: as any*/),
            {
              "alias": "blockedUser",
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "subject",
              "plural": false,
              "selections": [
                (v15/*:: as any*/),
                (v17/*:: as any*/),
                (v8/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "UserBlockedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v122/*:: as any*/),
          "type": "SubIssueAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v122/*:: as any*/),
          "type": "SubIssueRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v123/*:: as any*/),
          "type": "ParentIssueAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v123/*:: as any*/),
          "type": "ParentIssueRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "willCloseSubject",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "subject",
              "plural": false,
              "selections": (v99/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Commit",
              "kind": "LinkedField",
              "name": "commit",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "message",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "messageHeadlineHTML",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "messageBodyHTML",
                  "storageKey": null
                },
                (v27/*:: as any*/),
                (v116/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Repository",
                  "kind": "LinkedField",
                  "name": "repository",
                  "plural": false,
                  "selections": [
                    (v17/*:: as any*/),
                    (v48/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "defaultBranch",
                      "storageKey": null
                    },
                    (v8/*:: as any*/)
                  ],
                  "storageKey": null
                },
                (v8/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "ReferencedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v124/*:: as any*/),
          "type": "ConnectedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Repository",
              "kind": "LinkedField",
              "name": "fromRepository",
              "plural": false,
              "selections": [
                (v24/*:: as any*/),
                (v27/*:: as any*/),
                (v8/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "TransferredEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v124/*:: as any*/),
          "type": "DisconnectedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "duplicate",
              "plural": false,
              "selections": (v102/*:: as any*/),
              "storageKey": null
            },
            (v125/*:: as any*/),
            (v126/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanUndo",
              "storageKey": null
            }
          ],
          "type": "MarkedAsDuplicateEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v125/*:: as any*/),
            (v126/*:: as any*/)
          ],
          "type": "UnmarkedAsDuplicateEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Discussion",
              "kind": "LinkedField",
              "name": "discussion",
              "plural": false,
              "selections": [
                (v27/*:: as any*/),
                (v21/*:: as any*/),
                (v8/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "ConvertedToDiscussionEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v22/*:: as any*/),
            (v66/*:: as any*/),
            (v127/*:: as any*/)
          ],
          "type": "AddedToProjectV2Event",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*:: as any*/),
            (v127/*:: as any*/)
          ],
          "type": "RemovedFromProjectV2Event",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*:: as any*/),
            (v127/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "previousStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "type": "ProjectV2ItemStatusChangedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*:: as any*/),
          "type": "ConvertedFromDraftEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*:: as any*/),
            (v128/*:: as any*/),
            (v104/*:: as any*/)
          ],
          "type": "IssueTypeAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*:: as any*/),
            (v128/*:: as any*/)
          ],
          "type": "IssueTypeRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*:: as any*/),
            (v128/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "IssueType",
              "kind": "LinkedField",
              "name": "prevIssueType",
              "plural": false,
              "selections": (v93/*:: as any*/),
              "storageKey": null
            },
            (v104/*:: as any*/)
          ],
          "type": "IssueTypeChangedEvent",
          "abstractKey": null
        },
        (v40/*:: as any*/),
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    (v84/*:: as any*/)
  ],
  "storageKey": null
},
v130 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 0
  },
  (v95/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IssueViewerViewQuery",
    "selections": [
      {
        "kind": "CatchField",
        "field": {
          "alias": null,
          "args": (v7/*:: as any*/),
          "concreteType": "Repository",
          "kind": "LinkedField",
          "name": "repository",
          "plural": false,
          "selections": [
            (v9/*:: as any*/),
            (v10/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": [
                (v11/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "kind": "CatchField",
              "field": {
                "alias": null,
                "args": (v12/*:: as any*/),
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v9/*:: as any*/),
                  {
                    "args": [
                      (v13/*:: as any*/),
                      {
                        "kind": "Variable",
                        "name": "count",
                        "variableName": "count"
                      },
                      {
                        "kind": "Variable",
                        "name": "hideTimeline",
                        "variableName": "hideTimeline"
                      },
                      (v14/*:: as any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "IssueViewerIssue"
                  }
                ],
                "storageKey": null
              },
              "to": "RESULT"
            }
          ],
          "storageKey": null
        },
        "to": "RESULT"
      },
      (v20/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*:: as any*/),
      (v4/*:: as any*/),
      (v3/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v6/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "IssueViewerViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*:: as any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v8/*:: as any*/),
          (v10/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v16/*:: as any*/),
              (v11/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v12/*:: as any*/),
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v8/*:: as any*/),
              (v21/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanUpdateMetadata",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v8/*:: as any*/),
                  (v22/*:: as any*/),
                  (v17/*:: as any*/),
                  (v23/*:: as any*/),
                  (v24/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanInteract",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerInteractionLimitReasonHTML",
                    "storageKey": null
                  },
                  (v25/*:: as any*/),
                  (v26/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanPush",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                      (v16/*:: as any*/),
                      (v15/*:: as any*/),
                      (v8/*:: as any*/),
                      (v27/*:: as any*/),
                      (v22/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "issueFieldsEnabled",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v42/*:: as any*/),
                        "type": "Organization",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v42/*:: as any*/),
                        "type": "User",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v43/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isWritable",
                    "storageKey": null
                  },
                  (v10/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanPinIssues",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCopilotAgentEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v31/*:: as any*/),
                    "concreteType": "IssueTypeConnection",
                    "kind": "LinkedField",
                    "name": "issueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v39/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "issueTypes(first:100)"
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 3
                      }
                    ],
                    "concreteType": "PinnedIssueConnection",
                    "kind": "LinkedField",
                    "name": "pinnedIssues",
                    "plural": false,
                    "selections": (v29/*:: as any*/),
                    "storageKey": "pinnedIssues(first:3)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueCreationPermissions",
                    "kind": "LinkedField",
                    "name": "viewerIssueCreationPermissions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "triageable",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              (v44/*:: as any*/),
              (v27/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanUpdateNext",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v17/*:: as any*/),
                  (v45/*:: as any*/),
                  (v8/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isEnabled",
                    "storageKey": null
                  },
                  (v46/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedFields",
                    "plural": true,
                    "selections": (v41/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "duplicateOf",
                "plural": false,
                "selections": [
                  (v21/*:: as any*/),
                  (v27/*:: as any*/),
                  (v49/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "linkedPullRequests",
                "args": [
                  (v50/*:: as any*/),
                  {
                    "kind": "Literal",
                    "name": "includeClosedPrs",
                    "value": false
                  },
                  {
                    "kind": "Literal",
                    "name": "orderByState",
                    "value": true
                  }
                ],
                "concreteType": "PullRequestConnection",
                "kind": "LinkedField",
                "name": "closedByPullRequestsReferences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PullRequest",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Repository",
                        "kind": "LinkedField",
                        "name": "repository",
                        "plural": false,
                        "selections": [
                          (v17/*:: as any*/),
                          (v24/*:: as any*/),
                          (v48/*:: as any*/),
                          (v8/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v27/*:: as any*/),
                      (v21/*:: as any*/),
                      (v51/*:: as any*/),
                      (v52/*:: as any*/),
                      (v8/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:false,orderByState:true)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentAssignment",
                "kind": "LinkedField",
                "name": "agentAssignments",
                "plural": true,
                "selections": [
                  (v16/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Bot",
                    "kind": "LinkedField",
                    "name": "assignee",
                    "plural": false,
                    "selections": [
                      (v8/*:: as any*/),
                      (v15/*:: as any*/),
                      (v19/*:: as any*/),
                      (v53/*:: as any*/),
                      (v54/*:: as any*/),
                      (v55/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "assigner",
                    "plural": false,
                    "selections": [
                      (v16/*:: as any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isActor"
                      },
                      (v15/*:: as any*/),
                      (v8/*:: as any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v50/*:: as any*/),
                  {
                    "kind": "Literal",
                    "name": "includeClosedPrs",
                    "value": true
                  }
                ],
                "concreteType": "PullRequestConnection",
                "kind": "LinkedField",
                "name": "closedByPullRequestsReferences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PullRequest",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v8/*:: as any*/),
                      (v21/*:: as any*/),
                      (v27/*:: as any*/),
                      (v51/*:: as any*/),
                      (v22/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:true)"
              },
              {
                "alias": null,
                "args": [
                  (v30/*:: as any*/),
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": {
                      "direction": "ASC",
                      "field": "NAME"
                    }
                  }
                ],
                "concreteType": "LabelConnection",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  (v58/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*:: as any*/),
                          (v45/*:: as any*/),
                          (v17/*:: as any*/),
                          (v59/*:: as any*/),
                          (v46/*:: as any*/),
                          (v27/*:: as any*/),
                          (v60/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "labels(first:100,orderBy:{\"direction\":\"ASC\",\"field\":\"NAME\"})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Milestone",
                "kind": "LinkedField",
                "name": "milestone",
                "plural": false,
                "selections": [
                  (v8/*:: as any*/),
                  (v61/*:: as any*/),
                  (v62/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dueOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "progressPercentage",
                    "storageKey": null
                  },
                  (v27/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "closedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 20
                  }
                ],
                "concreteType": "AssigneeConnection",
                "kind": "LinkedField",
                "name": "assignedActors",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v16/*:: as any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*:: as any*/),
                          (v15/*:: as any*/),
                          (v17/*:: as any*/),
                          (v18/*:: as any*/),
                          (v19/*:: as any*/),
                          (v63/*:: as any*/)
                        ],
                        "type": "Actor",
                        "abstractKey": "__isActor"
                      },
                      (v40/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "assignedActors(first:20)"
              },
              (v64/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanComment",
                "storageKey": null
              },
              (v22/*:: as any*/),
              (v51/*:: as any*/),
              (v65/*:: as any*/),
              (v61/*:: as any*/),
              (v66/*:: as any*/),
              (v67/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v68/*:: as any*/),
                  (v15/*:: as any*/),
                  (v8/*:: as any*/),
                  (v69/*:: as any*/),
                  (v71/*:: as any*/),
                  (v72/*:: as any*/),
                  (v73/*:: as any*/),
                  (v16/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v53/*:: as any*/),
                      (v54/*:: as any*/)
                    ],
                    "type": "Bot",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v74/*:: as any*/),
              (v75/*:: as any*/),
              (v76/*:: as any*/),
              (v77/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PinnedIssueComment",
                "kind": "LinkedField",
                "name": "pinnedIssueComment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedBy",
                    "plural": false,
                    "selections": (v47/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueComment",
                    "kind": "LinkedField",
                    "name": "issueComment",
                    "plural": false,
                    "selections": [
                      (v8/*:: as any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 700
                          },
                          {
                            "kind": "Literal",
                            "name": "stripBlockElements",
                            "value": false
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "shortBodyHTML",
                        "storageKey": "shortBodyHTML(limit:700,stripBlockElements:false)"
                      },
                      (v66/*:: as any*/),
                      (v27/*:: as any*/),
                      (v78/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v16/*:: as any*/),
                          (v15/*:: as any*/),
                          (v68/*:: as any*/),
                          (v69/*:: as any*/),
                          (v8/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanAssign",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v80/*:: as any*/),
                "concreteType": "ProjectV2ItemConnection",
                "kind": "LinkedField",
                "name": "projectItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectV2ItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectV2Item",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*:: as any*/),
                          (v23/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v81/*:: as any*/),
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "fieldValueByName",
                            "plural": false,
                            "selections": [
                              (v16/*:: as any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*:: as any*/),
                                  (v82/*:: as any*/),
                                  (v17/*:: as any*/),
                                  (v59/*:: as any*/),
                                  (v45/*:: as any*/)
                                ],
                                "type": "ProjectV2ItemFieldSingleSelectValue",
                                "abstractKey": null
                              },
                              (v40/*:: as any*/)
                            ],
                            "storageKey": "fieldValueByName(name:\"Status\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectV2",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v8/*:: as any*/),
                              (v61/*:: as any*/),
                              (v62/*:: as any*/),
                              (v21/*:: as any*/),
                              (v27/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "template",
                                "storageKey": null
                              },
                              (v83/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasReachedItemsLimit",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v81/*:: as any*/),
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v16/*:: as any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v22/*:: as any*/),
                                      (v8/*:: as any*/),
                                      (v17/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProjectV2SingleSelectFieldOption",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": true,
                                        "selections": [
                                          (v8/*:: as any*/),
                                          (v82/*:: as any*/),
                                          (v17/*:: as any*/),
                                          (v59/*:: as any*/),
                                          (v45/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "descriptionHTML",
                                            "storageKey": null
                                          },
                                          (v46/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ProjectV2SingleSelectField",
                                    "abstractKey": null
                                  },
                                  (v40/*:: as any*/)
                                ],
                                "storageKey": "field(name:\"Status\")"
                              }
                            ],
                            "storageKey": null
                          },
                          (v16/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v84/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v57/*:: as any*/),
                      (v56/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v80/*:: as any*/),
                "filters": [
                  "allowedOwner",
                  "allowSameEnterprise"
                ],
                "handle": "connection",
                "key": "ProjectSection_projectItems",
                "kind": "LinkedHandle",
                "name": "projectItems"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanSetMilestone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPinned",
                "storageKey": null
              },
              (v85/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanTransfer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanConvertToDiscussion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanLock",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanSetFields",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v79/*:: as any*/)
                ],
                "concreteType": "IssueFieldValueConnection",
                "kind": "LinkedField",
                "name": "issueFieldValues",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v16/*:: as any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v16/*:: as any*/),
                              (v34/*:: as any*/),
                              (v40/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v86/*:: as any*/)
                        ],
                        "type": "IssueFieldTextValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v16/*:: as any*/),
                              (v35/*:: as any*/),
                              (v40/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v82/*:: as any*/),
                          (v17/*:: as any*/),
                          (v45/*:: as any*/),
                          (v46/*:: as any*/)
                        ],
                        "type": "IssueFieldSingleSelectValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v16/*:: as any*/),
                              (v36/*:: as any*/),
                              (v40/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IssueFieldSingleSelectOption",
                            "kind": "LinkedField",
                            "name": "options",
                            "plural": true,
                            "selections": [
                              (v8/*:: as any*/),
                              (v17/*:: as any*/),
                              (v45/*:: as any*/),
                              (v46/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "multiSelectValue",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "IssueFieldMultiSelectValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v16/*:: as any*/),
                              (v37/*:: as any*/),
                              (v40/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v86/*:: as any*/)
                        ],
                        "type": "IssueFieldDateValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v16/*:: as any*/),
                              (v38/*:: as any*/),
                              (v40/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "numberValue",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "IssueFieldNumberValue",
                        "abstractKey": null
                      },
                      (v40/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "issueFieldValues(first:25)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SubIssuesSummary",
                "kind": "LinkedField",
                "name": "subIssuesSummary",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "completed",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "pendingSuggestions",
                "plural": true,
                "selections": [
                  (v16/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*:: as any*/),
                      {
                        "alias": "typeState",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      (v66/*:: as any*/),
                      (v87/*:: as any*/),
                      (v89/*:: as any*/),
                      (v90/*:: as any*/),
                      (v91/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IssueType",
                        "kind": "LinkedField",
                        "name": "issueType",
                        "plural": false,
                        "selections": (v92/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "PendingTypeSuggestion",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*:: as any*/),
                      {
                        "alias": "labelState",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      (v66/*:: as any*/),
                      (v87/*:: as any*/),
                      (v89/*:: as any*/),
                      (v90/*:: as any*/),
                      (v91/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "label",
                        "plural": false,
                        "selections": (v92/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "PendingLabelSuggestion",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*:: as any*/),
                      {
                        "alias": "fieldState",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      (v66/*:: as any*/),
                      (v87/*:: as any*/),
                      (v89/*:: as any*/),
                      (v91/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "suggestedValue",
                        "storageKey": null
                      },
                      (v90/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "issueField",
                        "plural": false,
                        "selections": [
                          (v16/*:: as any*/),
                          (v40/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v70/*:: as any*/),
                            "type": "IssueFieldCommon",
                            "abstractKey": "__isIssueFieldCommon"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueFieldSingleSelectOption",
                                "kind": "LinkedField",
                                "name": "options",
                                "plural": true,
                                "selections": (v93/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "IssueFieldSingleSelect",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PendingFieldSuggestion",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*:: as any*/),
                      {
                        "alias": "closeState",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      (v66/*:: as any*/),
                      (v87/*:: as any*/),
                      (v89/*:: as any*/),
                      (v91/*:: as any*/),
                      (v90/*:: as any*/),
                      (v65/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "duplicateOf",
                        "plural": false,
                        "selections": [
                          (v16/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v94/*:: as any*/),
                            "type": "Issue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v94/*:: as any*/),
                            "type": "PullRequest",
                            "abstractKey": null
                          },
                          (v40/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PendingCloseSuggestion",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*:: as any*/),
                      {
                        "alias": "assigneeState",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      (v66/*:: as any*/),
                      (v87/*:: as any*/),
                      (v89/*:: as any*/),
                      (v90/*:: as any*/),
                      (v91/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "assignee",
                        "plural": false,
                        "selections": [
                          (v16/*:: as any*/),
                          (v40/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v55/*:: as any*/),
                              (v68/*:: as any*/)
                            ],
                            "type": "Actor",
                            "abstractKey": "__isActor"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v54/*:: as any*/)
                            ],
                            "type": "Bot",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PendingAssigneeSuggestion",
                    "abstractKey": null
                  },
                  (v40/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "condition": "hideTimeline",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "alias": "frontTimelineItems",
                    "args": (v96/*:: as any*/),
                    "concreteType": "IssueTimelineItemsConnection",
                    "kind": "LinkedField",
                    "name": "timelineItems",
                    "plural": false,
                    "selections": [
                      (v58/*:: as any*/),
                      (v28/*:: as any*/),
                      (v129/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "frontTimelineItems",
                    "args": (v96/*:: as any*/),
                    "filters": [
                      "visibleEventsOnly",
                      "skip"
                    ],
                    "handle": "connection",
                    "key": "Issue__frontTimelineItems",
                    "kind": "LinkedHandle",
                    "name": "timelineItems"
                  },
                  {
                    "alias": "backTimelineItems",
                    "args": (v130/*:: as any*/),
                    "concreteType": "IssueTimelineItemsConnection",
                    "kind": "LinkedField",
                    "name": "timelineItems",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPreviousPage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startCursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v28/*:: as any*/),
                      (v129/*:: as any*/)
                    ],
                    "storageKey": "timelineItems(last:0,visibleEventsOnly:true)"
                  },
                  {
                    "alias": "backTimelineItems",
                    "args": (v130/*:: as any*/),
                    "filters": [
                      "visibleEventsOnly"
                    ],
                    "handle": "connection",
                    "key": "Issue__backTimelineItems",
                    "kind": "LinkedHandle",
                    "name": "timelineItems"
                  }
                ]
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  (v97/*:: as any*/),
                  (v98/*:: as any*/)
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v20/*:: as any*/)
    ]
  },
  "params": {
    "id": "39d9663ba0233a929ed631420222f710",
    "metadata": {},
    "name": "IssueViewerViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "19c386247072874b83e0d990c8ea8076";

export default node;
